var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop"},React.createElement("g",{"id":"Machinery"},React.createElement("g",{"id":"Group-3"},React.createElement("path",{"id":"Fill-1","d":"M-242-15.93V15.91L-215.37,0ZM-243.53-20l.39,0,.37.16,31.05,18.53a1.49,1.49,0,0,1,0,2.55l-31.05,18.53A1.47,1.47,0,0,1-245,18.51v-37A1.5,1.5,0,0,1-243.91-20Z","transform":"translate(245 20)","style":{"fill":"#fff","fillRule":"evenodd"}})))));
}

PlayIcon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 34 40"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
